import { CryptoSwapsService } from "../services/cryptoSwaps.service";
import type { CreateOtcQuotePayload, OtcQuote } from "../types/cryptoSwaps.types";
import { useOtcQuote, type UseOtcQuoteResult } from "./useOtcQuote";

export type { RequestQuoteOptions } from "./useOtcQuote";

export type UseCryptoSwapQuoteResult = UseOtcQuoteResult<CreateOtcQuotePayload, OtcQuote>;

export function useCryptoSwapQuote(): UseCryptoSwapQuoteResult {
  return useOtcQuote(CryptoSwapsService.createQuote);
}
